import { useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { checkThirdLogin, googleCheckoutLogin } from "@/pages/api/auth";
import Image from "next/image";
import { toast } from "@/components/common/Toast";
import { GoogleAuthInfoInterface } from "@/interface/user";
import Cookies from "js-cookie";
import { eventBus, LOGIN_SUCCESS_EVENT } from "@/utils/eventBus";
import { useTranslation } from "react-i18next";
import { sendSlsEvent } from "@/hooks/useAnalytics";
import { GoogleIcon } from "@/components/icons";
import { useRouter } from "next/router";
interface GoogleThirdBtnProps {
  onSetThirdPsw: (googleInfo: any) => void;
  onFinish: () => void;
  pageId: string;
  buttonName: string;
}

const GoogleThirdBtn = ({
  onSetThirdPsw,
  onFinish,
  pageId,
  buttonName,
}: GoogleThirdBtnProps) => {
  const { t } = useTranslation();
  const router = useRouter();
  const code = router?.query?.code as string;
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const login = useGoogleLogin({
    onSuccess: async (response) => {
      setErrorMsg("");
      console.log("response", response);
      try {
        // 检查是否有access_token
        if (!response.access_token) {
          throw new Error("未收到Google访问令牌");
        }

        // 使用access_token获取用户信息
        const userInfoResponse = await fetch(
          `https://www.googleapis.com/oauth2/v2/userinfo?access_token=${response.access_token}`
        );

        if (!userInfoResponse.ok) {
          throw new Error("获取用户信息失败");
        }

        const userInfo = await userInfoResponse.json();
        console.log("userInfo", userInfo);

        const googleUserId = userInfo.id;
        const googleToken = response.access_token;

        // 调用后端校验
        const res = await googleCheckoutLogin({
          loginType: "google",
          id: googleUserId,
          token: googleToken,
          source: "0",
        });

        console.log("res-----", res);

        if (res && res.data) {
          if (res.code === "00000") {
            toast.success(t("login.suc"));
            if (res.data?.userInfoBaseResp?.token) {
              Cookies.set("token", res.data?.userInfoBaseResp?.token, {
                expires: 30,
                path: "/",
                sameSite: "lax",
              });
              Cookies.set("uid", String(res.data?.userInfoBaseResp?.id ?? ""), {
                expires: 30,
                path: "/",
                sameSite: "lax",
              });
              localStorage.setItem("isLoggedIn", "true");
              eventBus.emit(LOGIN_SUCCESS_EVENT, {
                userId: res?.data.userInfoBaseResp?.id,
                userInfoBaseResp: res?.data.userInfoBaseResp,
              });
              onFinish();
            }
          }
        } else {
          onSetThirdPsw({
            ...userInfo,
            token: googleToken,
          } as GoogleAuthInfoInterface);
        }
      } catch {
        // console.error("Google登录错误:", err);
        setErrorMsg(t("login.error"));
      }
    },
    onError: (error) => {
      setLoading(false);
      setErrorMsg(t("login.error"));
      console.error(error);
    },
    scope: "openid email profile",
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      }}
    >
      <div
        style={{
          backgroundColor: "#1673FF",
          color: "#fff",
          border: "1px solid #f2f2f2",
          borderRadius: "8px",
          height: "56px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "Mulish",
          fontSize: "16px",
          fontWeight: "700",
          width: "100%",
          marginBottom: "15px",
        }}
        onClick={() => {
          console.log("点击了Google登录");
          setLoading(true);
          sendSlsEvent({
            UM_Key_EventName: "UM_Event_ModularClick",
            UM_Key_ButtonName: buttonName,
            UM_Key_PageName: pageId,
            UM_Key_UserType: "Guest",
            UM_Key_SourcePage: router.route,
            UM_Key_ResourceID: code,
          });
          setErrorMsg("");
          login();
        }}
      >
        <GoogleIcon />
        <span style={{ marginLeft: "8px" }}>
          {t("login.continueWithGoogle")}
        </span>
      </div>
      {errorMsg && (
        <div style={{ color: "#f44336", marginTop: 8, fontSize: 14 }}>
          {errorMsg}
        </div>
      )}
    </div>
  );
};

export default GoogleThirdBtn;
